module.exports = __webpack_public_path__ + "static/media/front-cap.d1dc0ba7.png";